var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StepForm',{attrs:{"fullWidth":true}},[(!this.$store.state.comm.viewData)?_c('Loading'):_c('SentCommunicationOverview')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }